<template>
  <div class="feed-component">
    <!-- <div :class="{'content-form-container':true,'readonly':!editObj.edit}"> -->
    <el-form :model="form" :rules="rules" ref="form" class="form">
      <el-form-item label="饲料名称" :label-width="formLabelWidth" prop="name">
        <el-input
          v-model="form.name"
          :disabled="!editObj.edit"
          placeholder="请输入饲料名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="饲料类型" :label-width="formLabelWidth" prop="type">
        <el-select
          v-model="form.type"
          filterable
          :disabled="!editObj.edit"
          placeholder="请选择饲料类型"
        >
          <el-option
            v-for="(item, index) in feedTypeList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计量单位" :label-width="formLabelWidth" prop="unit">
        <el-select
          v-model="form.unit"
          filterable
          :disabled="!editObj.edit"
          placeholder="请选择计量单位"
          @change="changeUnit"
        >
          <el-option
            v-for="(item, index) in measurementUnitList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="规格"
        :label-width="formLabelWidth"
        prop="scaling"
      >
        <div class="scale">
          <el-input class="scal" :value="1" disabled></el-input>
          <span style="padding-left: 15px">{{
            form.unit ? form.unit : "袋"
          }}</span>
          <span style="padding: 0 15px">= </span>
          <el-input
            v-model="form.scaling"
            :disabled="!editObj.edit || show"
          ></el-input>
          <span style="padding: 0 15px">斤</span>
        </div>
      </el-form-item>
      <el-form-item label="单价" :label-width="formLabelWidth" prop="purchaseMoney">
        <el-input
          v-model="form.purchaseMoney"
          :disabled="!editObj.edit"
          placeholder="请输入单价"
          type="number"
        ></el-input>
      </el-form-item>
      <el-form-item prop="photoUrl" label="饲料图片">
        <el-upload
          :disabled="!editObj.edit"
          :class="{ siliaoHide: hideUpload }"
          :action="uploadImgUrl"
          :data="qiniuData"
          list-type="picture-card"
          :on-preview="imgPreview"
          :on-success="imgSuccess"
          :on-change="imgChange"
          :on-remove="imgRemove"
          :before-upload="imgBefore"
          :limit="uploadLimit"
          :headers="headers"
          :file-list="imgList"
          ref="imgUpload"
        >
          <i class="el-icon-plus">
            <h4 class="upload-tip"></h4>
          </i>
          <el-dialog :visible.sync="isShowImgDialog" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-upload>
      </el-form-item>
    </el-form>
    <div
      class="dialog-footer"
      v-if="$store.state.curCompany.isQlwVersion === true"
    >
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button
        type="primary"
        @click="save('form')"
        v-if="titleName !== '添加物资信息'"
        >保 存</el-button
      >
      <el-button
        type="primary"
        @click="saveEditData('form')"
        v-if="titleName === '编辑饲料信息'"
        >保 存</el-button
      >
    </div>
    <div
      class="dialog-footer"
      v-if="$store.state.curCompany.isQlwVersion !== true && editObj.edit"
    >
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button
        style="width: 110px"
        type="primary"
        @click="save('form', 'saveAndReset')"
        >保存后新增</el-button
      >
      <el-button
        type="primary"
        @click="save('form')"
        v-if="titleName !== '添加物资信息'"
        >保 存</el-button
      >
      <el-button
        type="primary"
        @click="saveEditData('form')"
        v-if="titleName === '编辑饲料信息'"
        >保 存</el-button
      >
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../../store";
export default Vue.extend({
  name: "FeedComponent",
  props: {
    dialogObj: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      // 可上传数量
      uploadLimit: 1,
      // 上传添加头部信息
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        method: "post",
      },
      // 图片服务器上传地址
      uploadImgUrl: "https://up-z2.qiniup.com",
      qiniuData: {
        token: "",
        key: "",
      },
      photoName: "",
      // 图片列表
      imgList: [],
      // 图片预览框
      dialogImageUrl: "",
      isShowImgDialog: false,
      // 是否隐藏图片上传框
      hideUpload: false,
      show: false,
      titleName: "",
      activeName: "first",
      formLabelWidth: "90px",
      form: {
        id: "",
        name: "",
        fishStockAbstract: 10001,
        unit: "",
        scaling: "",
        type: "",
        spec: "30",
        photoUrl: "",
      },
      feedTypeList: [],
      measurementUnitList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入饲料名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请先选择饲料单位",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请先选择计量单位",
            trigger: "blur",
          },
        ],
        scaling: [
          {
            required: true,
            message: "请输入规格系数",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(modules.materialSetting, [
      "materialSettingList",
      "dialogFormVisible",
      "editObj",
    ]),
  },

  async mounted() {
    this.feedTypeList = await this.getFeedUnit(); // 获取饲料类型
    this.measurementUnitList = await this.getMeasurementUnit(); // 获取计量单位
    if (this.editObj.category == "饲料") {
      this.form = await this.getMaterialView(this.editObj.id);
      if (this.form.photoUrl) {
        this.hideUpload = true;
        this.imgList = [
          {
            name: this.form.photoUrl,
            url: this.form.photoUrl,
          },
        ];
      } else {
        this.hideUpload = false;
        this.imgList = [];
      }
      if (
        this.form.unit == "千克" ||
        this.form.unit == "斤" ||
        this.form.unit == "克"
      ) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
    this.getToken();
  },
  methods: {
    ...mapActions(modules.dataDict, ["getFeedUnit", "getMeasurementUnit"]), //计量单位
    ...mapActions(modules.materialSetting, [
      "getMaterialSettingData", //查询
      "delMaterialSettingList", //删除
      "addMaterialSetting", //添加
      "getMaterialView",
      "updateMaterial",
    ]),
    ...mapMutations(modules.materialSetting, ["setDialogFormVisible"]),
    // 上传图片
    async getToken() {
      let res = await this.$api.getToken();
      if (res.data.code == 0) {
        let token = res.data.data;
        this.qiniuData.token = token;
      }
    },
    imgBefore() {
      this.qiniuData.key = this.guid();
    },
    // 图片上传成功
    imgSuccess(response) {
      this.photoName = "https://nfs.nxin.com/" + response.key;
      this.form.photoUrl = this.photoName;
    },

    // 图片上传改变
    imgChange(file, fileList) {
      this.hideUpload = fileList.length >= this.uploadLimit;
    },
    // 图片移除
    imgRemove(file, fileList) {
      if (fileList.length == 0) {
        this.imgList = [];
        this.form.photoUrl = "";
      }
      this.hideUpload = fileList.length >= this.uploadLimit;
    },
    // 图片预览
    imgPreview(file) {
      this.dialogImageUrl = file.url;
      this.isShowImgDialog = true;
    },
    changeUnit(e) {
      if (e == "克") {
        this.form.scaling = 0.002;
        this.show = true;
      } else if (e == "千克") {
        this.form.scaling = 2;
        this.show = true;
      } else if (e == "斤") {
        this.form.scaling = 1;
        this.show = true;
      } else {
        this.show = false;
      }
    },
    findNameByid(index, type) {
      if (this.measurementUnitList.length > 0 && typeof index == "number") {
        let obj = this.measurementUnitList.find((item) => {
          return item.id == index;
        });
        if (obj) {
          return obj.name;
        }
      }
      if (this.feedTypeList.length > 0) {
        let obj = this.feedTypeList.find((item) => {
          return item.id == index;
        });
        if (obj) {
          return obj.name;
        }
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    save(formName, isSaveAndReset) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.editObj.id) {
            this.form.id = this.editObj.id;
            this.form.spec =
              this.form.scaling +
              "斤" +
              "/" +
              (this.form.unit ? this.form.unit : "袋");
            this.updateMaterial(this.form).then(() => {
              // this.setDialogFormVisible(false);
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$emit("update");
              if (isSaveAndReset === 'saveAndReset') {
                this.saveAndResetFn(this.form.unit)
              } else {
                this.setDialogFormVisible(false);
              }
            }).catch((err) => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error",
                });
              });
          } else {
            this.form.spec =
              this.form.scaling +
              "斤" +
              "/" +
              (this.form.unit ? this.form.unit : "袋");
            this.addMaterialSetting(this.form)
              .then(() => {
                // this.setDialogFormVisible(false);
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.$emit("update");
                if (isSaveAndReset === 'saveAndReset') {
                  this.saveAndResetFn(this.form.unit)
                } else {
                  this.setDialogFormVisible(false);
                }
              })
              .catch((err) => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error",
                });
                // this.$message({
                //   message: "保存失败",
                //   type: "error"
                // });
              });
          }
        }
      });
    },
    cancel() {
      this.setDialogFormVisible(false);
      console.log("quxiao");
    },
    saveAndResetFn(unit){
      this.editObj.id = ''
      this.form = {
        id: "",
        name: "",
        fishStockAbstract: 10001,
        unit,
        scaling: "",
        type: "",
        spec: "30",
        photoUrl: "",
      }
    }
  },
});
</script>

<style lang="stylus">
.siliaoHide{
  .el-upload{
    display: none;
  }
}
.feed-component
  .el-form-item__content{
    margin-left:120px!important
    .el-input{
      width:500px;
    }
  }
  .el-upload--picture-card {
    margin-left: 12px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    margin-left: 12px;
  }
  .scale
    .el-input_inner
      width:50px!important;
    input
      // text-align center;

  .scal
    input
      border:1px solid #e0e0e0;
      background-color: #f3f3f3;
      color: #999;
      cursor: not-allowed;
  .el-form .el-form-item .el-form-item__label:before
    position:absolute;
    top: 2px;
    left: 0px;
    color:red;
  .el-form .el-form-item .el-form-item__label
    padding-left:20px;
</style>
